import {combineReducers} from 'redux'
import menu from './menuReducer'
import user from './userReducer'
import towns from './townsReducer'
import courses from './coursesReducer'
import report from './reportReducer'
//import courseFilter from './courseFilterReducer'

const agentapp = combineReducers({
  menu,
  user,
  towns,
  courses,
  report,
//  courseFilter
})

export default agentapp


// WEBPACK FOOTER //
// ./src/reducers/index.js